const putList = (listData) => {
  const { listId, name, isPublic } = listData;

  return fetch(`/lists/rs/${listId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, isPublic }),
  });
};

const deleteList = (listId) =>
  fetch(`/lists/rs/${listId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });

const deleteItem = (data) => {
  const { listId, item } = data;
  return fetch(`/lists/rs/${listId}/${item}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

const updateItem = (data) => {
  const { listId, item, quantity, note, newListId } = data;

  return fetch(`/lists/rs/${listId}/${item}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ quantity, note, listId: newListId }),
  });
};

const addComment = (data) => {
  const { listId, item, note } = data;

  return fetch(`/lists/rs/${listId}/${item}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ note }),
  });
};

const addToCart = async (data) => {
  const { item, sku, quantity, termsCategoryAgreedTo } = data;

  const fetchPayload = {
    sku,
    quantity,
    wishlistEntryId: item,
  };
  if (termsCategoryAgreedTo) {
    fetchPayload.termsCategoryAgreedTo = termsCategoryAgreedTo;
  }
  const response = await fetch('/lists/rs/cart/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(fetchPayload),
  });
  return response;
};

const getTermsAndConditions = (sku) =>
  fetch(`/rest/cart/terms/${sku}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

const getCart = () =>
  fetch('/rest/cart/', {
    method: 'GET',
    headers: {
      Accept: 'application/json;v=2',
    },
  });

export default {
  putList,
  deleteList,
  deleteItem,
  updateItem,
  addComment,
  addToCart,
  getTermsAndConditions,
  getCart,
};
